<template>
    <div class="productIncAndDescMain">
        <div class="minusWrapper" @click="purchasedNumberDesc">
            <div class="minusIcon" />
        </div>
        <div class="purchaseNumber" @click="purchasedNumberCustom">
            {{ value }}
        </div>
        <div class="addWrapper" @click="purchasedNumberInc">
            <div class="addIcon1" />
            <div class="addIcon2" />
        </div>
    </div>
</template>

<script>

import ProductNumberOfShop from "@/components/shop/ProductNumberOfShop.vue";

export default {
    name: "ProductIncAndDesc",

    components: {
        ProductNumberOfShop,
    },

    props: {
        value: {
            type: Number,
            default: 0,
        },

        maxBuyNum: {
            type: Number,
            default: 99999999,
        },

        maxNumber: {
            type: Number,
            default: 99999999,
        },
    },

    methods: {
        purchasedNumberDesc()
        {
            if(this.value <= 0)
            {
                return;
            }

            //
            this.$emit("input", this.value - 1);

            //
            this.$emit("dataChange", -1);
        },

        purchasedNumberCustom()
        {
            let self = this;

            //
            this.createComponent(ProductNumberOfShop, {
                on: {
                    dataChange(val)
                    {
                        if(self.maxBuyNum < parseInt(val))
                        {
                            return self.Toast(`当前商品只能否买${self.maxBuyNum}件`);
                        }

                        if(self.maxNumber < parseInt(val))
                        {
                            return self.Toast(`当前商品库存不足`);
                        }

                        //
                        self.$emit("input", parseInt(val));

                        //
                        self.$emit("dataChange", parseInt(val - self.value));
                    },
                },

                props: {
                    initNumber: parseInt(self.value),
                },
            })
        },

        purchasedNumberInc()
        {
            if(this.maxBuyNum < this.value + 1)
            {
                return this.Toast(`当前商品最多购买${this.maxBuyNum}件`);
            }

            if(this.maxNumber < this.value + 1)
            {
                return this.Toast(`当前商品库存不足`);
            }
            
            //
            this.$emit("input", this.value + 1);

            //
            this.$emit("dataChange", 1);
        },
    }
}
</script>

<style lang="scss" scoped>

.productIncAndDescMain
{
    display: flex; 
    align-items: center; 
    justify-content: center;
    font-size: $fontSizeContent;
    line-height: 2em;
}

//
.minusWrapper {
    position: relative;
    width: 2em;
    height: 2em;
    border: 0.01rem solid #23AFF2;
    box-sizing: border-box;
    border-radius: $borderRadius;
}

.minusIcon {
    position: absolute;
    left: 0.5em;
    top: 1em;
    width: 1em;
    height: 0.01rem;
    background-color: $neutralFontMainColor;
}

//
.purchaseNumber
{
    width: 2em;
    text-align: center;
}

//
.addWrapper {
    position: relative;
    width: 2em;
    height: 2em;
    background-color: $primaryColor;
    border-radius: $borderRadius;
}

.addIcon1 {
    position: absolute;
    left: 0.5em;
    top: 1em;
    width: 1em;
    height: 0.01rem;
    background-color: $neutralFontMainColor;
}

.addIcon2 {
    @extend .addIcon1;

    transform-origin: center;
    transform: rotate(90deg);
}
</style>